import styled from 'styled-components';

import { WithThemeProps, pxToRem } from '../../styles';


const Root = styled.div`
	position: relative;
	display: inline-flex;
	width: 100%;
	min-height: 82px;
	outline: none;
`;

const ContentLayout = styled.div`
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	padding: 16px;
	cursor: pointer;

	${(p: WithThemeProps) => `
		color: ${p.theme.palette.accentPrimary};
		border: 1px dashed ${p.theme.palette.accentPrimary};
	`}
`;

const DropzoneItemsLayout = styled.div`
	width: 100%;
	flex: 1 1 auto;
`;

const DropzoneItem = styled.div`
	font-size: ${pxToRem(12)};

	${(p: WithThemeProps) => `
		color: ${p.theme.palette.blackSecondary};
	`}
`;

export {
	Root,
	ContentLayout,
	DropzoneItemsLayout,
	DropzoneItem,
}
